import React from 'react';

const Chip = () => (
  <svg
    width="32"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <mask
      id="a"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="24"
    >
      <path
        d="M25.8 0H5.4A5.4 5.4 0 0 0 0 5.4v13.2A5.4 5.4 0 0 0 5.4 24h20.4a5.4 5.4 0 0 0 5.4-5.4V5.4A5.4 5.4 0 0 0 25.8 0Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        d="M5.4.5h20.4a4.9 4.9 0 0 1 4.9 4.9v13.2a4.9 4.9 0 0 1-4.9 4.9H5.4a4.9 4.9 0 0 1-4.9-4.9V5.4A4.9 4.9 0 0 1 5.4.5Z"
        fill="#FFC12D"
        stroke="#D8A427"
      />
      <path
        d="M19.872 4.506C18.783 2.464 17.272 1.2 15.6 1.2c-3.314 0-6 4.97-6 11.1s2.686 11.1 6 11.1c3.313 0 6-4.97 6-11.1 0-1.261-.114-2.474-.324-3.603"
        stroke="#D8A427"
      />
      <path
        d="M21.674 15.9h9.436M.074 8.7H9.51.074Zm0 3.6h27.223H.074Zm0 0h27.223H.074Zm0 7.8h27.223H.074Zm0-15.6h27.223H.074Zm0 11.4H9.51.074Zm21.223-7.2h9.813-9.813Z"
        stroke="#D8A428"
      />
    </g>
  </svg>
);

export default Chip;
